// extracted by mini-css-extract-plugin
export default {"text":"styles_text__Y8wjA"};